import { register } from '@/utils/sw-register-service';

async function unregisterLegacySW () {
  if (!('serviceWorker' in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();

  for (const registration of registrations) {
    const swUrl = registration.active?.scriptURL ?? registration.waiting?.scriptURL ?? '';

    if (swUrl.endsWith('/sw.js')) {
      console.debug('Unregistering legacy /sw.js');
      await registration.unregister();
    }
  }
}

export async function registerWorker () {
  await unregisterLegacySW();

  register('/service-worker.js', {
    registrationOptions: {
      scope: '/',
    },
    ready (registration) {
      console.debug('Service worker is active.');
    },
    registered (registration) {
      setInterval(() => {
        registration.update();
      }, 600000); // check every 10 minutes
    },
    updated (registration) {
      document.dispatchEvent(
        new CustomEvent('sw:updated', { detail: registration }),
      );
      console.debug('Service worker: new content is available; please refresh.');

      // Auto-activate after 5 minutes if the user hasn't clicked the snackbar
      setTimeout(() => {
        if (registration.waiting) {
          console.debug('Service worker: auto-activating after timeout.');
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }, 5 * 60 * 1000);
    },
  });
  register('/js/firebase-messaging-sw.js', {
    ready (registration) {
      console.debug('Firebase service worker is active.');
    },
  });
}
